var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Accordion } from "radix-ui";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixAccordion = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var uiTheme = useDataUiTheme();
    return (React.createElement(Accordion.Root, __assign({ ref: ref, "data-ui-theme": uiTheme }, props), children));
});
export var RadixAccordionItem = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var uiTheme = useDataUiTheme();
    return (React.createElement(Accordion.Item, __assign({ ref: ref, "data-ui-theme": uiTheme }, props), children));
});
export var RadixAccordionHeader = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var uiTheme = useDataUiTheme();
    return (React.createElement(Accordion.Header, __assign({ ref: ref, "data-ui-theme": uiTheme }, props), children));
});
export var RadixAccordionTrigger = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var uiTheme = useDataUiTheme();
    return (React.createElement(Accordion.Trigger, __assign({ ref: ref, "data-ui-theme": uiTheme }, props), children));
});
export var RadixAccordionContent = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var uiTheme = useDataUiTheme();
    return (React.createElement(Accordion.Content, __assign({ ref: ref, "data-ui-theme": uiTheme }, props), children));
});
RadixAccordion.displayName = "RadixAccordion";
RadixAccordionItem.displayName = "RadixAccordionItem";
RadixAccordionHeader.displayName = "RadixAccordionHeader";
RadixAccordionTrigger.displayName = "RadixAccordionTrigger";
RadixAccordionContent.displayName = "RadixAccordionContent";
